import '@polymer/polymer/polymer-legacy.js';
import '@polymer/paper-spinner/paper-spinner-lite.js';
import './canvasPanZoom.js';
import { Polymer } from '@polymer/polymer/lib/legacy/polymer-fn.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';

Polymer({
  _template: html`
    <style>
      :host {
        display: block;
        float: left;
        position: relative;
        /*border: 1px solid #b1b1b1;*/
        /* border: 1px solid rgba(0,0,0,0.2); */
        height: 100%;
        width: 100%;
        box-sizing: border-box;
        outline: none;
        background-color: white;
      }

      #canvas {
        height: 100%;
        width: 100%;
        box-sizing: border-box;
      }

      paper-spinner-lite {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -14px;
        margin-left: -14px;
        z-index: 10;
        pointer-events: none;
        --paper-spinner-color: var(--secondary-color);
      }

      paper-spinner-lite.overlay {
        top: 66%;
      }

      #overlay {
        position: absolute;
        display: none;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        box-sizing: border-box;
        background-color: rgba(100, 100, 100, 0.7);
        color: white;
        text-align: center;
        z-index: 3;
      }
      #overlay.showing {
        display: block;
      }

      #overlayText {
        position: absolute;
        top: 25%;
        width: 100%;
        box-sizing: border-box;
      }

      #scaledContent {
        position: absolute;
        top: 0px;
        left: 0;
        z-index: 2;
        pointer-events: none;
      }

      #scaledContent ::slotted(*) {
        position: absolute;
        z-index: 3;
      }

      #nonScaledContent {
        position: absolute;
        top: 0px;
        left: 0;
        height: 100%;
        width: 100%;
        z-index: 3;
        pointer-events: none;
      }
    </style>
    <paper-spinner-lite active="{{getLoading(loader, imageLoaded)}}" class$="{{getSpinnerClass(overlay)}}"></paper-spinner-lite>
    <div id="overlay" class$="{{getOverlayShowing(overlay)}}" style$="{{overlay.style}}">
      <div id="overlayText">{{getOverlayText(overlay)}}</div>
    </div>
    <canvas
      id="canvas"
      on-click="tapCanvas"
      on-mouseup="mouseUpCanvas"
      on-mousemove="mouseMoveCanvas"
      on-contextmenu="rightClickCanvas"
      scroll-sensitivity="[[scrollSensitivity]]"
    ></canvas>
    <div id="scaledContent">
      <slot name="scale"></slot>
    </div>
    <div id="controlContent">
      <slot name="photoButtons"></slot>
    </div>
    <div id="nonScaledContent">
      <slot></slot>
    </div>
  `,

  is: 'katapult-photo',

  properties: {
    autoResize: {
      type: Boolean,
      value: false,
      observer: 'setAutoResize'
    },
    autoResizeInterval: {
      type: Number,
      value: null
    },
    autoResizePeriod: {
      type: Number,
      value: 100
    },
    backgroundColor: {
      type: String,
      value: '#FAFAFA'
    },
    noFit: {
      type: Boolean,
      value: false
    },
    library: {
      type: Boolean,
      value: false
    },
    imageLoaded: {
      type: Boolean,
      value: false
    },
    loader: {
      type: Boolean,
      value: false
    },
    noTransition: {
      type: Boolean,
      value: false
    },
    noCache: {
      type: Boolean,
      value: false
    },
    overlay: {
      type: String,
      value: '',
      reflectToAttribute: true
    },
    persistentOverlay: {
      type: Boolean,
      value: false
    },
    preserveZoom: {
      type: Boolean,
      value: false
    },
    pictureHeight: {
      notify: true
    },
    pictureWidth: {
      notify: true
    },
    rotation: {
      type: Number,
      observer: 'rotationChanged'
    },
    scale: {
      type: Number,
      value: -1,
      observer: 'rescaleCanvas'
    },
    src: {
      type: String,
      observer: 'srcChanged'
    },
    zoom: {
      type: Boolean,
      value: false,
      observer: 'zoomChanged'
    },
    scrollSensitivity: {
      type: Number,
      value: 1.0
    },
    preloadSrc: {
      type: String,
      observer: 'preloadSrcChanged'
    }
  },

  observers: ['updateFilters(filters.*)'],

  created: function () {
    this.preloadImg = new Image();
    this.preloadImg.addEventListener('load', () => {
      this.preloadImageLoaded = true;
      if (!this.imageLoaded) {
        this._img = this.preloadImg;
        this._imgType = 'preload';
        this.orientateImage();
      }
      this.fire('image-loaded');
    });
    this.preloadImg.addEventListener('error', (e) => this.imageLoadError(e));

    this.img = new Image();
    this.img.addEventListener('load', () => {
      this.imageLoaded = true;
      this._img = this.img;
      this._imgType = 'preferred';
      const _cachedPreserveZoom = this.preserveZoom;
      this.preserveZoom = true;
      this.orientateImage();
      this.preserveZoom = _cachedPreserveZoom;
      this.fire('image-fully-loaded');
    });
    this.img.addEventListener('error', (e) => this.imageLoadError(e));
  },

  detached: function () {
    clearInterval(this.autoResizeInterval);
  },

  ready: function () {
    this.setupCanvas();

    // Code for auto updating size.
    this.prevOffsetWidth = 0;
    this.prevOffsetHeight = 0;
    this.sizeChanged = false;
  },

  setAutoResize: function () {
    if (this.autoResizeInterval) {
      clearInterval(this.autoResizeInterval);
      this.autoResizeInterval = null;
    }
    if (this.autoResize) {
      this.autoResizeInterval = setInterval(() => this.checkResize(), 300);
    }
  },

  checkResize: function () {
    let offsetWidth = this.offsetWidth;
    let offsetHeight = this.offsetHeight;
    let differenceTolerance = 1;
    if (
      Math.abs(offsetWidth - this.prevOffsetWidth) > differenceTolerance ||
      Math.abs(offsetHeight - this.prevOffsetHeight) > differenceTolerance
    ) {
      var preserveZoom = this.preserveZoom;
      this.preserveZoom = true;
      this.orientateImage();
      this.preserveZoom = preserveZoom;
      this.prevOffsetHeight = offsetHeight;
      this.prevOffsetWidth = offsetWidth;
      this.fire('resize', { offsetHeight, offsetWidth });
    }
  },

  setupCanvas: function () {
    // Ignore subsequent calls if we've already initialized
    if (this.canvasInitialized) return;
    this.canvasInitialized = true;

    // Set up the canvas
    if (this.zoom) canvasPanZoomOn(this.$.canvas, () => this.redraw(), { transformOverlay: () => this.transformContent() }, false);
    else canvasInit(this.$.canvas, () => this.redraw());

    this.$.scaledContent.addEventListener('mousewheel', (e) => {
      if (this.zoom) canvasWheel.call(this.$.canvas, e);
    });
  },

  getOverlayShowing: function (overlay) {
    if (overlay != null && overlay != '' && overlay.text != '') {
      return 'showing';
    } else {
      return '';
    }
  },

  getOverlayText: function (overlay) {
    if (overlay != null && overlay.text != null) {
      return overlay.text;
    } else {
      return overlay;
    }
  },

  zoomChanged: function () {
    if (this.$) {
      if (this.zoom) canvasPanZoomOn(this.$.canvas, () => this.redraw(), { transformOverlay: () => this.transformContent() }, false);
      else canvasPanZoomOff(this.$.canvas);
    }
  },

  pan: function (direction) {
    var x = 0;
    var y = 0;
    if (direction == 'up') {
      y = this.$.canvas.height / this.$.canvas.scale / 2;
    } else if (direction == 'down') {
      y = -(this.$.canvas.height / this.$.canvas.scale) / 2;
    }
    smartPan(this.$.canvas, x, y);
    this.redraw();
  },

  rotationChanged: function () {
    this.orientateImage();
  },

  orientateImage: function (offsetHeight, offsetWidth) {
    // Optional.  Can save performance if passed in from earlier.
    if (!offsetWidth) offsetWidth = this.offsetWidth;
    if (!offsetHeight) offsetHeight = this.offsetHeight;

    const someImageLoaded = (this.imageLoaded && this._imgType == 'preferred') || (this.preloadImageLoaded && this._imgType == 'preload');
    if (someImageLoaded) {
      var w = this._img?.width;
      var h = this._img?.height;

      if (this.rotation == 1 || this.rotation == 3) {
        var t = w;
        w = h;
        h = t;
      }

      var imageHW = h / w;
      var elementHW = offsetHeight / offsetWidth;
      this.$.canvas.width = offsetWidth;
      this.$.canvas.height = offsetHeight;
      if (elementHW > imageHW && !this.noFit) {
        this.$.canvas.pictureWidth = this.$.canvas.width;
        this.$.canvas.pictureHeight = this.$.canvas.width * imageHW;
      } else {
        this.$.canvas.pictureHeight = this.$.canvas.height;
        this.$.canvas.pictureWidth = this.$.canvas.height / imageHW;
      }
      this.$.canvas.pictureX = (this.$.canvas.width - this.$.canvas.pictureWidth) / 2;
      this.$.canvas.pictureY = (this.$.canvas.height - this.$.canvas.pictureHeight) / 2;
      this.$.canvas.originalScale = this.$.canvas.height / h;

      if (this.preserveZoom && this.$.canvas.ctx.currentTransform) {
        var currentTransform = this.$.canvas.ctx.currentTransform();
        this.$.canvas.scale = currentTransform.a;
        this.$.canvas.ctx.setTransform(
          currentTransform.a,
          currentTransform.b,
          currentTransform.c,
          currentTransform.d,
          currentTransform.e,
          currentTransform.f
        );
      } else {
        this.$.canvas.scale = 1;
        this.$.canvas.ctx.setTransform(1, 0, 0, 1, 0, 0);
      }
    }

    this.updateFilters();

    this.transformContent({ offsetHeight, offsetWidth, forceMarkerRecalc: true });
    if (this.imageLoaded && this.library && this.scale > 0) {
      var scale = (this.scale * 72) / this.$.canvas.clientHeight;
      this.$.canvas.ctx.save();
      clearCanvas(this.$.canvas);
      this.colorCanvas(this.backgroundColor);
      this.$.canvas.scale = scale;
      this.$.canvas.ctx.translate(((1 - scale) * this.$.canvas.width) / 2, ((1 - scale) * this.$.canvas.height) / 2);
      this.$.canvas.ctx.scale(scale, scale);
      this.$.canvas.ctx.drawImage(
        this._img,
        this.$.canvas.pictureX,
        this.$.canvas.pictureY,
        this.$.canvas.pictureWidth,
        this.$.canvas.pictureHeight
      );
      this.$.canvas.ctx.restore();
    }
  },

  rescaleCanvas: function (n, o) {
    if (this.library && this.$.canvas.ctx) {
      var scale = (n * 72) / this.$.canvas.clientHeight,
        canvas = this.$.canvas;
      canvas.ctx.save();
      clearCanvas(canvas);
      this.colorCanvas(this.backgroundColor);
      if (n > 0) {
        canvas.scale = scale;
        canvas.ctx.translate(((1 - scale) * this.$.canvas.width) / 2, ((1 - scale) * this.$.canvas.height) / 2);
        canvas.ctx.scale(canvas.scale, canvas.scale);
        canvas.ctx.drawImage(this._img, canvas.pictureX, canvas.pictureY, canvas.pictureWidth, canvas.pictureHeight);
      } else {
        this.$.canvas.scale = 1;
        canvas.ctx.drawImage(this._img, canvas.pictureX, canvas.pictureY, canvas.pictureWidth, canvas.pictureHeight);
      }
      canvas.ctx.restore();
    }
  },

  imageLoadError: function (e) {
    this.imageLoaded = true;
    this.imageError = true;
    this.overlay = 'Error Loading Photo';
    this.fire('loading-image-error', e);
    console.log('FAILED TO LOAD PHOTO', e);
  },

  transformContent: function (options) {
    options = options || {};
    // Optional.  Can save performance if passed in from earlier.
    if (!options.offsetWidth) options.offsetWidth = this.offsetWidth;
    if (!options.offsetHeight) options.offsetHeight = this.offsetHeight;
    if (this.$.canvas.ctx) {
      var currentTransform = this.$.canvas.ctx.currentTransform();
      var height = this.$.canvas.pictureHeight * currentTransform.d;
      var width = this.$.canvas.pictureWidth * currentTransform.a;
      this.$.scaledContent.style.height = height + 'px';
      this.$.scaledContent.style.width = width + 'px';
      this.$.scaledContent.style.top =
        ((options.offsetHeight - this.$.canvas.pictureHeight) / 2) * currentTransform.d + currentTransform.f + 'px';
      this.$.scaledContent.style.left =
        ((options.offsetWidth - this.$.canvas.pictureWidth) / 2) * currentTransform.a + currentTransform.e + 'px';
      // Only fire zoomed if we actually zoomed in (unless options.forceMarkerRecalc is set)
      if (this.lastCanvasScale != this.$.canvas.scale || options.forceMarkerRecalc == true) {
        this.fire('zoomed', { height: height, width: width, scale: this.$.canvas.scale });
      }
      this.lastCanvasScale = this.$.canvas.scale;
    }
  },

  redraw: function () {
    const someImageLoaded = (this.imageLoaded && this._imgType == 'preferred') || (this.preloadImageLoaded && this._imgType == 'preload');
    if (someImageLoaded && !this.imageError) {
      this.colorCanvas(this.backgroundColor);
      const canvas = this.$.canvas;
      const rotation = this.rotation || 0;
      if (rotation != 0) {
        canvas.ctx.save();
        canvas.ctx.translate(canvas.width / 2, canvas.height / 2);
        canvas.ctx.rotate((rotation * Math.PI) / 2);
        let w = canvas.width;
        let h = canvas.height;
        let { x, y, width: pW, height: pH } = this.getPictureDimensions();
        if (rotation == 1 || rotation == 3) {
          let t = w;
          w = h;
          h = t;
          t = x;
          x = y;
          y = t;
          t = pW;
          pW = pH;
          pH = t;
        }
        canvas.ctx.translate(-w / 2, -h / 2);
        canvas.ctx.drawImage(this._img, x, y, pW, pH);
        canvas.ctx.restore();
      } else {
        canvas.ctx.drawImage(this._img, canvas.pictureX, canvas.pictureY, canvas.pictureWidth, canvas.pictureHeight);
      }
    }
  },

  colorCanvas: function (rgba) {
    this.$.canvas.ctx.save();
    this.$.canvas.ctx.setTransform(1, 0, 0, 1, 0, 0);
    this.$.canvas.ctx.fillStyle = rgba;
    this.$.canvas.ctx.fillRect(0, 0, this.$.canvas.width, this.$.canvas.height);
    this.$.canvas.ctx.restore();
  },

  preloadSrcChanged: function (preloadSrc) {
    if (!!preloadSrc) this.preloadImg.src = preloadSrc;
  },

  srcChanged: function (src) {
    this.setupCanvas();
    const srcIsValid = !!src;
    if (!this.noTransition) {
      this.colorCanvas(this.backgroundColor);
      this.imageLoaded = false;
      this.noTransition = false;
    }

    // Clear any image errors
    this.imageError = false;

    if (srcIsValid) {
      if (!this.persistentOverlay) this.overlay = '';
      const suffix = this.noCache ? `${src.includes('?') ? '&' : '?'}useFromCache=false` : '';
      this.img.src = `${src}${suffix}`;
    }
  },

  getPercentXY: function (event) {
    var position = this.offsetCoordinates(event);
    var percentX = (position.x / (this.$.canvas.pictureWidth / this.$.canvas.originalScale)) * 100;
    var percentY = (position.y / (this.$.canvas.pictureHeight / this.$.canvas.originalScale)) * 100;
    return { percentX: percentX, percentY: percentY };
  },

  mouseUpCanvas: function (e) {
    if (e) this.fire('photo-mouseup', e);
  },

  tapCanvas: function (event, detail, center) {
    if (this.$.canvas.mouseWasDragged) {
      this.$.canvas.mouseWasDragged = false;
    } else {
      var position = this.getPercentXY(event);
      position.originalEvent = event;
      this.fire('photo-tap', position);
    }
  },

  rightClickCanvas: function (e) {
    var position = this.getPercentXY(e);
    position.originalEvent = e;
    this.fire('photo-right-click', position);
  },

  mouseMoveCanvas: function (event, detail, sender) {
    this.fire('photo-mouse-move', this.getPercentXY(event));
  },

  offsetCoordinates: function (e) {
    var totalOffset = this.totalOffset(this.$.canvas);
    var ctxCoords = this.$.canvas.ctx.canvasToContext({
      x: e.x - totalOffset.x,
      y: e.y - totalOffset.y
    });
    var picX = (ctxCoords.x - this.$.canvas.pictureX) / this.$.canvas.originalScale;
    var picY = (ctxCoords.y - this.$.canvas.pictureY) / this.$.canvas.originalScale;
    return {
      x: picX,
      y: picY
    };
  },

  totalOffset: function (element) {
    var totalOffsetX = 0;
    var totalOffsetY = 0;
    do {
      totalOffsetX += element.offsetLeft;
      totalOffsetY += element.offsetTop;
    } while ((element = element.offsetParent));
    return {
      x: totalOffsetX,
      y: totalOffsetY
    };
  },

  updateFilters: function () {
    if (this.$?.canvas.ctx) {
      let temp = '';
      for (let key in this.filters) {
        temp += `${key}(${this.filters[key]}%)`;
      }
      this.$.canvas.ctx.filter = temp;
    }
    this.redraw();
  },

  getLoading: function (loader, imageLoaded) {
    return loader || !imageLoaded;
  },

  getSpinnerClass: function (overlay) {
    return overlay ? 'overlay' : '';
  },

  getPictureDimensions: function () {
    const canvas = this.$.canvas;
    return {
      width: canvas.pictureWidth,
      height: canvas.pictureHeight,
      x: canvas.pictureX,
      y: canvas.pictureY
    };
  },

  clearPhoto: function () {
    this.src = null;
    this.imageLoaded = false;
    this.colorCanvas(this.backgroundColor);
  }
});
